const actionTypes = require('constants/actionTypes');
const { APIPost } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');
const { DATE_FORMAT_API, CARDS } = require('constants/index');
const { CARD_ACTIVATION_GREATER_THAN_ONE_YEAR } = require('constants/flagBasedFeatures');
const { getCardType, getCardData } = require('utilities/cardsHelper');
const {
    APLAZADO_TAE,
    APLAZADO_TIN,
} = require('constants/AFISimulator.js');

const cardActivationRequest = () => ({
    type: actionTypes.SET_CARD_ACTIVATION_REQUEST
});

const cardActivationSuccess = () => ({
    type: actionTypes.SET_CARD_ACTIVATION_SUCCESS
});

const cardActivationFailure = error => ({
    type: actionTypes.SET_CARD_ACTIVATION_FAILURE,
    payload: { error }
});

const clearCardActivation = () => ({
    type: actionTypes.SET_CARD_ACTIVATION_RESET
});

const activateCard = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const isCreditCard = immCard.get('type') === CARDS['CREDIT'] && getState().flagBasedFeatures.get(CARD_ACTIVATION_GREATER_THAN_ONE_YEAR)
        const immGlobalVariables = getState().globalVariables
        const cardType = getCardType(immCard);
        const tin = getCardData(cardType, APLAZADO_TIN, immGlobalVariables);
        const tae = getCardData(cardType, APLAZADO_TAE, immGlobalVariables);

        const params = {
            query: {
                dataToken,
                contratoTarjeta: {
                    numerodecontrato: immCard.getIn(['contract', 'number']),
                    producto: immCard.getIn(['contract', 'product'])
                },
                fechaCaducidad: immCard.get('expirationDate').format(DATE_FORMAT_API),
                numeroContrato: immCard.getIn(['contract', 'number']),
                numeroTarjeta: immCard.get('number'),
                producto: immCard.getIn(['contract', 'product']),
                ...(isCreditCard && {
                    standard: immCard.getIn(['criteria', 'c1', 'estand']),
                    subProductType: immCard.getIn(['criteria', 'c1', 'subtipoproducto']),
                    amount: immCard.getIn(['limit', 'amount']),
                    tae: Number(tae.replace(/%/g, '').replace(',', '.')),
                    interestRate : Number(tin.replace(/%/g, '').replace(',', '.')) / 100
                })
            },
            ...(isCreditCard && {
                header: {
                    version : __CONTACT_CENTER__ ? 2 : 4,
                }
            })
        };

        dispatch(cardActivationRequest());
        return APIPost({
            dispatch,
            endpoint: 'cardActivation',
            params
        })
            .then(response => {
                return dispatch(cardActivationSuccess(response));
            })
            .catch(response => {
                return dispatch(cardActivationFailure(response.error));
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    activateCard,
    clearCardActivation
};
